import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import '../styles.scss';

interface ProjectsEmptyProps {
    hasFilters: boolean;
}

export const ProjectsEmpty: React.FC<ProjectsEmptyProps> = ({ hasFilters }) => {
    return (
        <div className="flex items-center justify-center w-full projects-empty-container">
            <div className="flex flex-col items-center justify-center border border-gray-200 rounded-lg bg-white w-full max-w-3xl h-96">
                <div className="text-center">
                    <div className="w-14 h-14 bg-neutral-100 rounded-lg flex items-center justify-center mb-3.5 mx-auto">
                        <FontAwesomeIcon
                            icon="fa-light fa-telescope"
                            className="h-4 w-4 text-base-mutedForeground"
                        />
                    </div>
                    <p className="text-xl font-semibold text-gray-900 mb-2.5">
                        {hasFilters ? 'No exact matches' : 'No projects found'}
                    </p>
                    <p className="text-sm font-normal text-gray-900">
                        {hasFilters
                            ? 'Try changing or removing some of your filters or adjusting your search area'
                            : "You don't have any projects yet"}
                    </p>
                </div>
            </div>
        </div>
    );
};
